import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const DiagramIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Top node */}
      <rect x="7" y="2" width="10" height="5" rx="1" />
      {/* Bottom-left node */}
      <rect x="1" y="17" width="10" height="5" rx="1" />
      {/* Bottom-right node */}
      <rect x="13" y="17" width="10" height="5" rx="1" />
      {/* Line from top to bottom-left */}
      <path d="M9 7v4l-3 6" />
      {/* Line from top to bottom-right */}
      <path d="M15 7v4l3 6" />
    </svg>
  );
});

DiagramIcon.displayName = 'DiagramIcon';
